import clsx from "clsx";
import { InputHTMLAttributes, forwardRef } from "react";
import styles from "./TextInput.module.scss";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
	errorMessage?: string;
	innerIcon?: React.ReactNode;
}

const TextInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
	const { innerIcon, errorMessage = false, className, ...rest } = props;

	if (innerIcon) {
		return (
			<div className={styles.inputContainer}>
				<input
					{...rest}
					className={clsx([
						styles.input,
						errorMessage ? styles.error : null,
						className,
					])}
					ref={ref}
				/>
				{innerIcon}
			</div>
		);
	}

	return (
		<input
			{...rest}
			className={clsx([
				styles.input,
				errorMessage ? styles.error : null,
				className,
			])}
			ref={ref}
		/>
	);
});

export default TextInput;
